<template>
    <section class="home_banner_section">
        <a-carousel autoplay v-model="bannerActive" height="500px" :style="{ backgroundColor: `#FFF` }">
            <div :key="index" :id="index" v-for="(item, index) in bannerCarousels">
                <img class="carousel_img" :src="item.NewsPhoto" />
            </div>
        </a-carousel>
    </section>
    <section class="hotel_group_section">
        <div class="group_bady">
            <div class="group_title">
                <h2><i class="iconfont icontianxie"></i>填写定制游需求&nbsp;<span>24小时定制游咨询热线&nbsp;0755-82321158</span></h2>
                <p>提交需求后,我们将在10分钟内回电您,确认需求并提供方案!</p>
            </div>

            <div class="group_form">
                <!-- Swiper -->
                <div class="group_img">
                    <div class="swiper-container">
                        <img id="Group" :src="groupImg" alt="" />
                    </div>
                </div>
                <div>
                    <a-form :model="form" ref="formRef" :rules="rules">
                        <!-- 出发城市-->
                        <a-form-item label="出发城市" :label-col="{ span: 4 }" name="departureName">
                            <a-row>
                                <a-col :span="8">
                                    <a-input v-model:value="form.departureName" placeholder="请输入出发城市"
                                        style="width: 100%;" />
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="目的城市" :label-col="{ span: 8 }" name="destinationName">
                                        <a-input v-model:value="form.destinationName" placeholder="请输入目的城市" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-form-item>

                        <!-- 出行日期和退房日期 -->
                        <a-form-item label="出行日期" :label-col="{ span: 4 }">
                            <a-row :gutter="[50]">
                                <a-col :span="8">
                                    <a-form-item :name="'checkInDate'">
                                        <a-date-picker v-model:value="form.checkInDate" placeholder="选择出行日期"
                                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                                            :disabled-date="disabledCheckInDate" style="width: 100%;" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="回程日期" :label-col="{ span: 8 }" name="checkOutDate">
                                        <a-date-picker v-model:value="form.checkOutDate" placeholder="选择回程日期"
                                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                                            :disabled-date="disabledCheckOutDate" :disabled="!form.checkInDate"
                                            style="width: 100%;" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-form-item>
                        <!-- 预算金额 团队性质-->
                        <a-form-item label="人均预算" :label-col="{ span: 4 }" name="budget">
                            <a-row>
                                <a-col :span="8">
                                    <a-input-number v-model:value="form.budget" min="0" style="width: 90%;"
                                        placeholder="请输入人均预算" />
                                    <span class="bed">元</span>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="出游性质" :label-col="{ span: 8 }" name="tourType">
                                        <a-select v-model:value="form.tourType" placeholder="请选择出游性质"
                                            style="width: 100%;">
                                            <!-- <a-select-option value="0">请选择</a-select-option> -->
                                            <a-select-option value="1">个人定制</a-select-option>
                                            <a-select-option value="2">公司定制</a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-form-item>
                        <!-- 出行人数 房间数量-->
                        <a-form-item label="出行人数" :label-col="{ span: 4 }" name="adults">
                            <a-row>
                                <a-col :span="8">
                                    <a-input-number v-model:value="form.adults" min="1" step="1" style="width: 100%;"
                                        placeholder="请输入出行人数" />
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="儿童" :label-col="{ span: 8 }" name="childs">
                                        <a-input-number v-model:value="form.childs" min="1" style="width: 100%;"
                                            placeholder="请输入儿童数量" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-form-item>
                        <!-- 项目需求-->
                        <a-form-item label="项目需求" :label-col="{ span: 4 }" name="additionalDemand">
                            <a-row>
                                <a-col :span="16">
                                    <a-checkbox-group v-model:value="form.additionalDemand">
                                        <a-checkbox value="1">路线设计</a-checkbox>
                                        <a-checkbox value="2">机票</a-checkbox>
                                        <a-checkbox value="3">用车</a-checkbox>
                                        <a-checkbox value="4">导游</a-checkbox>
                                        <a-checkbox value="5">酒店</a-checkbox>
                                        <a-checkbox value="6">签证</a-checkbox>
                                        <a-checkbox value="7">门票</a-checkbox>
                                        <a-checkbox value="8">用餐</a-checkbox>
                                    </a-checkbox-group>
                                </a-col>
                            </a-row>
                        </a-form-item>

                        <!-- 联系人信息-->
                        <a-form-item label="联系人" :label-col="{ span: 4 }" name="contactName">
                            <a-row>
                                <a-col :span="8">
                                    <a-input v-model:value="form.contactName" placeholder="请输入联系人姓名"
                                        style="width: 100%;" />
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="手机" :label-col="{ span: 8 }" name="phone">
                                        <a-input v-model:value="form.phone" placeholder="请输入手机号码" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-form-item>

                        <!-- 微信和QQ -->
                        <a-form-item label="微信" :label-col="{ span: 4 }">
                            <a-row>
                                <a-col :span="8">
                                    <a-input v-model:value="form.weChat" placeholder="请输入微信号" />
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="QQ" :label-col="{ span: 8 }">
                                        <a-input v-model:value="form.qq" placeholder="请输入QQ号码" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-form-item>


                        <!-- 固话和邮箱-->
                        <a-form-item label="固话" :label-col="{ span: 4 }">
                            <a-row>
                                <a-col :span="8">
                                    <a-input v-model:value="form.landline" placeholder="请输入固话" />
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="邮箱" :label-col="{ span: 8 }">
                                        <a-input v-model:value="form.email" type="email" placeholder="请输入邮箱" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-form-item>

                        <!-- 其他补充 -->
                        <a-form-item label="其他补充" :label-col="{ span: 4 }">
                            <a-row>
                                <a-col style="width: 83%;">
                                    <a-textarea v-model:value="form.remark" placeholder="请输入补充信息" />
                                </a-col>
                            </a-row>
                        </a-form-item>
                        <!-- 提交按钮 -->
                        <a-form-item>
                            <a-row justify="center">
                                <a-col>
                                    <a-button type="primary" size="large" @click="onSubmit"
                                        style="width: 200px; font-size: 16px;">
                                        提交
                                    </a-button>
                                </a-col>
                            </a-row>
                        </a-form-item>


                    </a-form>
                </div>

            </div>
        </div>
    </section>
    <!--热卖推荐-->
    <section class="hotel_hotsale_section">

        <a-tabs v-model="hotCities" class="hot_house">
            <a-tab-pane tab="热卖酒店">
                <a-row :gutter="16">
                    <a-col :span="6" v-for="data in hotCities" :key="data.HotelId">
                        <a :href="`/hotel/detail?hotelId=` + data.HotelId" class="hot_house_piece">

                            <a-card hoverable>
                                <template #cover>
                                    <a-image :preview="false" :alt="data.HotelName" :src="data.PhotoUrl"
                                        fallback="https://img.etxing.com/b2b/images/hotelDefault.svg" />
                                </template>
                                <a-card-meta :title="data.HotelName">
                                    <template #description>

                                        <div class="house_info">

                                            <a-rate :value="data.Star" disabled style="font-size: 12px"></a-rate>
                                            <p><span class="hot_price">￥{{ data.LowestPrice }}</span><span
                                                    class="hot_site">{{ data.HotelArea
                                                    }}</span></p>
                                        </div>

                                    </template>
                                </a-card-meta>
                            </a-card>
                        </a>
                    </a-col>
                </a-row>
            </a-tab-pane>
        </a-tabs>

    </section>
</template>

<script>
import '@/assets/styles/home.css';
import { Form, Select, Row, Col, FormItem, Button, Input, DatePicker, Checkbox, InputNumber } from 'ant-design-vue';
import dayjs from 'dayjs';
import { useUserStore } from '@/assets/stores/userStore';
// import address from '@/assets/js/address.json';
// import router from "@/assets/router";
export default {
    name: 'HomePage',
    data() {
        return {
            form: {
                checkInDate: null,
                checkOutDate: null,
                departureName: "",
                destinationName: "",
                budget: null,
                tourType: "",
                adults: null,
                childs: 0,
                additionalDemand: ["1"],
                contactName: "",
                phone: "",
                weChat: "",
                qq: "",
                landline: "",
                email: "",
                remark: ""
            },
            rules: {
                departureName: [
                    { required: true, message: '出发城市是必填项', trigger: 'blur' },
                ],
                destinationName: [
                    { required: true, message: '目的城市是必填项', trigger: 'blur' },
                ],
                checkInDate: [
                    { validator: this.checkInDateValidator, trigger: 'blur' }
                ],
                checkOutDate: [
                    { validator: this.checkOutDateValidator, trigger: 'blur' }
                ],
                budget: [
                    { required: true, message: '人均预算是必填项', trigger: 'blur' },
                    { pattern: /^([1-9]\d*|0\.\d+|[1-9]\d*\.\d+)$/, message: '必须为大于 0 的数字', trigger: 'blur' }
                ],
                adults: [
                    { required: true, message: '出行人数是必填项', trigger: 'blur' },
                    { pattern: /^[1-9]\d*$/, message: '格式有误', trigger: 'blur' }
                ],
                childs: [
                    { pattern: /^[0-9]\d*$/, message: '格式有误', trigger: 'blur' }
                ],
                contactName: [
                    { required: true, message: '联系人是必填项', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '手机是必填项', trigger: 'blur' },
                    { pattern: /^(13|15|17|18)\d{9}$/, message: '格式有误', trigger: 'blur' }
                ],
                tourType: [
                    { required: true, message: '出游性质是必填', trigger: 'blur' },
                ],
                email: [
                    { pattern: /^\w+@\w+(\.\w+){1,2}$/, message: '格式有误', trigger: 'blur' }
                ],
                remark: [
                    { pattern: /[`~!@#$%^&*()_\-+=<>?"{}\\/'[\]]/im, message: '有非法字符', trigger: 'blur' }
                ]
            },
            bannerActive: 0,
            bannerCarousels: [],
            groupImg: "",
            hotCities: []  // 保存随机选出的城市数据
        }
    },
    components: {
        'a-form': Form,
        'a-form-item': FormItem,
        'a-select': Select,
        'a-select-option': Select.Option,
        'a-row': Row,
        'a-col': Col,
        'a-button': Button,
        'a-input': Input,
        'a-input-number': InputNumber,
        'a-date-picker': DatePicker,
        'a-checkbox': Checkbox,
        'a-checkbox-group': Checkbox.Group,
        'a-textarea': Input.TextArea
    },
    created() {
        // 在 created 中初始化 Pinia store
        this.userStore = useUserStore();
        // this.countries = address;
    },
    mounted() {
        this.fetchCarousel();
        this.fetchHotSale();
        document.title = this.$route.meta.title;
    },
    computed: {
        // 使用 Pinia Store 来获取 user 信息
        // memberInfo() {
        //     return this.userStore.memberData.Member;
        // }
    },
    methods: {
        fetchCarousel() {
            this.$axios.post('/carousel', { "BannerType": "customized,travelad", "Status": "1" })
                .then(response => {

                    if (response.data.RetCode == "Success") {
                        this.bannerCarousels = response.data.Banners.filter(banner => banner.BannerType === "customized")
                        this.bannerActive = 0;
                        this.groupImg = response.data.Banners.filter(banner => banner.BannerType === "travelad")[0].NewsPhoto;
                    } else {
                        console.log(response.data)
                    }

                });
        },
        fetchHotSale() {
            this.$axios.get('/hotSale')
                .then(response => {
                    if (response.data.RetCode == "Success") {
                        //console.log("response", response);
                        const hotCityData = response.data.HotHotels || [];  // 如果为 undefined，则使用空数组
                        const hotCityData_ = response.data.OverSeaHotHotels || [];  // 同上
                        // console.log("hotCityData", hotCityData);
                        //console.log("hotCityData_", hotCityData_);
                        // 合并两个数据源
                        const hotCity_Data = hotCityData.concat(hotCityData_);
                        //  console.log("hotCity_Data", hotCity_Data);
                        // 获取6个随机项并更新 hotCities
                        this.hotCities = this.getArrayItems(hotCity_Data, 8);
                        // console.log("hotCities", this.hotCities);
                    } else {
                        console.log(response.data)
                    }

                });
        },

        // 禁用小于今天的日期
        disabledCheckInDate(current) {
            // current 是当前日期
            return current && current < dayjs().startOf('day'); // 禁用今天之前的日期
        },

        // 禁用小于入住日期的退房日期
        disabledCheckOutDate(current) {
            const { checkInDate } = this.form;
            if (!checkInDate) return false; // 如果入住日期为空，退房日期不禁用

            return current && current <= dayjs(checkInDate).endOf('day'); // 禁用小于入住日期的退房日期
        },

        // 入住日期验证，不能小于今天
        checkInDateValidator(rule, value) {
            return new Promise((resolve, reject) => {
                if (!value) {
                    reject('出行日期是必填项');
                } else {
                    // 获取今天的日期，时分秒都设为 0
                    // console.log(value);
                    const today = new Date();
                    //today.setHours(0, 0, 0, 0); // 重置时分秒

                    // 比较入住日期的年月日部分
                    if (value < today) {
                        reject('出行日期不能小于今天');
                    } else {
                        resolve();
                    }
                }
            });
        },

        // 退房日期验证，必须大于入住日期
        checkOutDateValidator(rule, value) {
            return new Promise((resolve, reject) => {
                if (!value) {
                    reject('回程日期是必填项');
                } else if (value <= this.form.checkInDate) {
                    reject('回程日期必须大于入住日期');
                } else {
                    resolve();
                }
            });
        },
        // 随机从数组中选取 num 个不重复项
        getArrayItems(arr, num) {
            const temp_array = [...arr];  // 创建一个数组副本
            const return_array = [];
            for (let i = 0; i < num; i++) {
                if (temp_array.length > 0) {
                    const arrIndex = Math.floor(Math.random() * temp_array.length);
                    return_array.push(temp_array.splice(arrIndex, 1)[0]);  // 从数组中移除并返回
                } else {
                    break;
                }
            }
            return return_array;
        },

        // 提交按钮点击事件
        onSubmit() {
            this.$refs.formRef.validate()
                .then(() => {
                    var additionalDemands = this.form.additionalDemand.join(",");
                    var MemberInfo = this.userStore.memberData.Member;
                    //console.log(MemberInfo);

                    var data = {
                        TourType: this.form.tourType,
                        MembersId: MemberInfo.Id || 0,
                        DepartureName: this.form.departureName,
                        DestinationName: this.form.destinationName,
                        Budget: this.form.budget,
                        StartTime: this.form.checkInDate,
                        EndTime: this.form.checkOutDate,
                        Adults: this.form.adults,
                        Childs: this.form.childs,
                        Contacts: this.form.contactName,
                        CellPhone: this.form.phone,
                        Telephone: this.form.landline,
                        Email: this.form.email,
                        Wechat: this.form.weChat,
                        QQ: this.form.qq,
                        Remark: this.form.remark,
                        AdditionalDemand: additionalDemands
                    };

                    this.$axios.post('/tourism', data)
                        .then(response => {
                            if (response.data.RetCode === "Success") {
                                this.$success({
                                    title: '恭喜您',
                                    content: '提交定制游成功,我们将在10分钟内确认需求并提供方案,请耐心等候我们联系您！',
                                    okText: '关闭',
                                    onOk() {
                                        setTimeout(() => {
                                            window.location.reload();
                                        }, 100);
                                    }
                                });
                            }
                            else {

                                var message = response.data.RetMessage || "";
                                if (response.data.Error && response.data.Error.ErrorMessage) message = response.data.Error.ErrorMessage;

                                this.$error({
                                    title: '啊哦~',
                                    content: message,
                                    okType: 'danger',
                                    okText: '请刷新重试',
                                    onOk() {
                                        setTimeout(() => {
                                            window.location.reload();
                                        }, 100);
                                    },
                                });
                            }
                        }).catch(error => {
                            console.error("Error fetching hotel rates:", error);
                        });
                })
                .catch((error) => {
                    // 验证失败
                    console.log('表单验证失败', error);
                });
        },
    }
}
</script>


<style scoped>
.hotel_group_section {
    background: #fff;
}

.group_bady {
    width: 1190px;
    margin: 0 auto;
}

.group_bady .group_title {
    position: relative;
    height: 80px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 40px;
}

.group_bady .group_title h2 {
    font-size: 22px;
    line-height: 80px;
    color: #333;
}

.group_bady .group_title h2 span {
    font-size: 14px;
    color: #669933;
}

.group_bady .group_title h2 i {
    font-size: 30px;
    padding-right: 10px;
    position: relative;
    top: 2px;
}

.group_bady .group_title p {
    position: absolute;
    top: 40px;
    right: 0px;
    font-size: 14px;
    color: red;
}

.group_form {
    /* width: 860px; */
    padding-left: 350px;
    position: relative;
}

.group_form .group_img {
    position: absolute;
    top: 0px;
    left: -20px;
}

.group_form .group_img img {
    width: 340px;
    height: 600px;
    border: 1px solid #eee;
}

.group_form .group_img .swiper-container {
    width: 350px;
    height: 630px;
    padding: 10px 50px 50px 50px;
}

.group_form .group_img .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 350px;
    height: 630px;
}
</style>